//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { AbstractControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ExceptionsService } from './exceptions-service';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })

export class ValidatorService {

  constructor(
    private exceptionsService: ExceptionsService
  ) { }

  //RBW_20260114 - Currently only works with boolean controls, the result line will need updating if strings are to be checked
  public eitherOrValidator(ctrlName1:string, ctrlName2:string, validationMessage:string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      try {
        const value =control.value;
        const parent=control.parent;
        if (!parent) return null;
  
        const ctrl1 = parent.get(ctrlName1);
        const ctrl2 = parent.get(ctrlName2);
        var result = ctrl1 && ctrl2 && ctrl1.value == true && ctrl2.value == true ? { eitherOr: { message: validationMessage } } : null;
        return result;
      } catch (e) {
        this.exceptionsService.handleException(<Error>e);
        return null;
      }
    }
  }

  public dateMustBeFutureValidator(control: AbstractControl): null | ValidationErrors {
    try {
      const value=control.value;

      if (!value)
        return null;

      const today: Date=new Date();

      today.setHours(0, 0, 0, 0);

      const picked: Date=typeof value==="string" && /^\d{4}-\d{2}-\d{2}$/.test(value)
                          ? new Date(Number(value.substring(0, 4)),
                                     Number(value.substring(5, 7)) - 1,
                                     Number(value.substring(8, 10)))
                          : new Date(value);

      picked.setHours(0, 0, 0, 0);

      if (isNaN(picked.getTime()))
        return { invalidDate: true };

      return picked.getTime() < today.getTime() ? { dateInPast: true } : null;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return null;
    }
  }

  public dateMustNotBeFutureValidator(control: AbstractControl): null | ValidationErrors {
    try {
      const value=control.value;

      if (!value)
        return null;

      const today: Date=new Date();

      today.setHours(0, 0, 0, 0);

      const picked: Date=typeof value==="string" && /^\d{4}-\d{2}-\d{2}$/.test(value)
                          ? new Date(Number(value.substring(0, 4)),
                                     Number(value.substring(5, 7)) - 1,
                                     Number(value.substring(8, 10)))
                          : new Date(value);

      picked.setHours(0, 0, 0, 0);

      if (isNaN(picked.getTime()))
        return { invalidDate: true };

      return picked.getTime() > today.getTime() ? { dateInFuture: true } : null;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return null;
    }
  }

  public emailValidator(control: AbstractControl): null | ValidationErrors {
    try {
      const value=control.value;

      if (!value)
        return null;
      
      //const emailRegex=/^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const emailRegex=/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})*$/;
  
      return emailRegex.test(value) ? null : { invalidEmail: true };
    } catch (e) {
      this.exceptionsService.handleException(<Error>e);
      return null;
    }
  }
  
  public forbiddenIdValidator(forbiddenId: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      try {
        return Number(control.value)===forbiddenId ? { forbiddenValue: true } : null;
      }
      catch(e) {
        this.exceptionsService.handleException(<Error>e);
        return null;
      }
    };
  }

  public greaterThanZeroValidator(control: AbstractControl): null | ValidationErrors {
    try {
      const value=control.value;

      if (value===null || value===undefined || value==="") {
        return { required: true };
      }
    
      const numericValue=Number(value);
    
      if (isNaN(numericValue) || numericValue <= 0) {
        return { greaterThanZero: true };
      }
    
      return null;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return null;
    }
  }
  
  public guidValidator(control: AbstractControl): null | ValidationErrors {
    try {
      const value=control.value;

      if (!value)
        return null;
    
      const guidRegex=/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/;
      
      return guidRegex.test(value) ? null : { invalidGuid: true };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return null;
    }
  }
  
  public isRequired(untypedFormGroup: UntypedFormGroup, path: string, requiredAsterisk: boolean): boolean {
    try {
      if (!requiredAsterisk)
        return false;

      const abstractControl: AbstractControl | null=untypedFormGroup.get(path);
      
      if (abstractControl && typeof (abstractControl as any).hasValidator==="function") {
        return (abstractControl as any).hasValidator(Validators.required);
      }
      
      if (abstractControl?.validator) {
        const result=abstractControl.validator(abstractControl);
        
        return !!result && result["required"]===true;
      }
      
      return false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public mandatoryWhenControlXSetValidator(controlXName:string, ctrlName:string, validationMessage:string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      try {
        const value =control.value;
        const parent=control.parent;
        if (!parent) return null;
  
        const ctrlX = parent.get(controlXName);
        const ctrl  = parent.get(ctrlName);
        var result  = ctrl  && (ctrl.value == undefined || ctrl.value  == null || ctrl.value == "") && 
                      ctrlX && ctrlX.value != undefined && ctrlX.value != null  && ctrlX.value != ""? { mandatoryWhenComponentXSet: { message: validationMessage } } : null;
        return result;
      } catch (e) {
        this.exceptionsService.handleException(<Error>e);
        return null;
      }
    }
  }

  public multipleEmailValidator(control: AbstractControl): null | ValidationErrors {
    try {
      const value=control.value;

      if (!value)
        return null;

      const emailRegex=/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(;\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})*$/;

      return emailRegex.test(value) ? null : { invalidEmail: true };
    } catch (e) {
      this.exceptionsService.handleException(<Error>e);
      return null;
    }
  }

  public mustBeEmptyValidator(control: AbstractControl): null | ValidationErrors {
    try {
      const value   =control.value;
      const hasValue=value !== null && value !== undefined && value.toString().trim() !== "";

      return hasValue ? { mustBeEmpty: true } : null;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return null;
    }
  }

  public mustEqualValidator(requiredValue: number, errorKey: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      try {
        return Number(control.value) === requiredValue ? null : { [errorKey]: true };
      }
      catch(e) {
        this.exceptionsService.handleException(<Error>e);
        return null;
      }
    };
  }

  public mustBeOneOfValidator(allowedValues: number[], errorKey: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      try {
        return allowedValues.includes(Number(control.value)) ? null : { [errorKey]: true };
      }
      catch(e) {
        this.exceptionsService.handleException(<Error>e);
        return null;
      }
    };
  }

  public selectionRequiredValidator(control: AbstractControl): null | ValidationErrors {
    try {
      const value      =control.value;
      const notSelected=value === null || value === undefined || value === "" || Number(value) === 0;

      return notSelected ? { required: true } : null;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return null;
    }
  }

  public setOrClearValidators(untypedFormGroup: UntypedFormGroup,
                              controlName     : string,
                              setValidators   : boolean,
                              validators?     : ValidatorFn[]): void {
    try {
      if (setValidators) {
        if (validators)
          untypedFormGroup.get(controlName)?.setValidators(validators!);
      
      } else {
        untypedFormGroup.get(controlName)?.clearValidators();
      }
      
      untypedFormGroup.get(controlName)?.updateValueAndValidity();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public urlValidator(control: AbstractControl): null | ValidationErrors {
    try {
      const value=control.value;

      if (!value)
        return null;

      const trimmed: string=String(value).trim();

      if (!trimmed)
        return null;

      const candidate: string=/^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(trimmed) ? trimmed : 'https://' + trimmed;
      let   parsed   : URL;

      try {
        parsed=new URL(candidate);
      }
      catch {
        return { invalidURL: true };
      }

      if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:')
        return { invalidURL: true };

      const hostname: string=parsed.hostname;

      if (!hostname || hostname.indexOf(' ') !== -1)
        return { invalidURL: true };

      const isIpLiteral: boolean=hostname.startsWith('[') || /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname);

      if (!isIpLiteral && !/^[^\s.]+(\.[^\s.]+)+$/.test(hostname))
        return { invalidURL: true };

      return null;
    } catch (e) {
      this.exceptionsService.handleException(<Error>e);
      return null;
    }
  }

  public valueInListValidator(allowedValues: () => (string | null | undefined)[], errorKey: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      try {
        const list = allowedValues() ?? [];

        return list.indexOf(control.value) === -1 ? { [errorKey]: { value: control.value } } : null;
      }
      catch(e) {
        this.exceptionsService.handleException(<Error>e);
        return null;
      }
    };
  }
  
  public valueNotInListValidator(forbiddenValues: () => (string | null | undefined)[], errorKey: string, normalise?: (value: string | null | undefined) => string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      try {
        const list = forbiddenValues() ?? [];

        if (normalise) {
          const target = normalise(control.value);

          return target !== "" && list.some(x => normalise(x) === target) ? { [errorKey]: { value: control.value } } : null;
        }

        return list.indexOf(control.value) !== -1 ? { [errorKey]: { value: control.value } } : null;
      }
      catch(e) {
        this.exceptionsService.handleException(<Error>e);
        return null;
      }
    };
  }

  public valueValidForParamValidator(paramControlName: string,
                                     targetParam     : string,
                                     acceptedValues  : string[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      try {
        const parent=control.parent;

        if (!parent)
          return null;

        const paramCtrl=parent.get(paramControlName);

        if (!paramCtrl)
          return null;

        const param=(paramCtrl.value ?? "").toString().trim().toLowerCase();

        if (param !== targetParam.trim().toLowerCase())
          return null;

        const typed   =(control.value ?? "").toString().trim();
        const accepted=acceptedValues.map(v => v.trim().toLowerCase());

        if (accepted.indexOf(typed.toLowerCase()) !== -1)
          return null;

        const message=`ConfigSystem '${targetParam}' - invalid value '${typed}'. Accepted values are: ${acceptedValues.join(", ")}.`;

        return { valueInvalidForParam: { message: message } };
      } catch (e) {
        this.exceptionsService.handleException(<Error>e);
        return null;
      }
    }
  }
}
